import { DomainDesignModel } from '../models/DomainDesignModel';

const StryderDesign: DomainDesignModel = {
  clientkey: 'stryder',
  created: '2023-02-21T13:13:48.6570736+13:00',
  modified: '2023-02-21T13:13:48.6570736+13:00',
  assets: {
    skinThemes: {
      auth: {
        backgroundImage: 'medical-research-background-2.jpg',
        companyLogo: 'medical-research-logo.svg',
        termsAndConditions: 'TermsAndConditions.html',
        privacyStatement: 'PrivacyStatement.html'
      },
      container: {
        favicon: 'medical-research-fav-icon.svg',
        siteName: 'Stryder',
        headerFontColor: '#ffffff',
        headerColor: '#4c81bd',
        headerLogo: 'stryder-logo-light-blue.svg',
        fontImport:
          'https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700'
      },
      group: {
        adminCardColor: '#c04e58',
        reviewerCardColor: '#4c81bd',
        memberCardColor: '#30383e'
      },
      dashboard: {
        backgroundImage: 'background-1.jpg'
      }
    },
    muiThemes: {
      palette: {
        primary: {
          main: '#e74c3c',
          dark: '#cf4536',
          light: '#f55240'
        },
        secondary: {
          main: '#bad6f0',
          dark: '#a5bed6',
          light: '#c2e0fc',
          contrastText: '#30383e'
        }
      },
      typography: {
        fontFamily: '"Poppins","Roboto","Helvetica","Arial","sans-serif"'
      }
    }
  }
};
export default StryderDesign;
